import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import { MenuProps } from 'components/Menu/Types'
import { ImageEffect, stringOrNumber } from '@cloudinary/url-gen/types/types'
import { ItemProps } from '@react-types/shared'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import * as adjust from '@cloudinary/url-gen/actions/adjust'
import * as effect from '@cloudinary/url-gen/actions/effect'
import { camelCase, snakeCase } from 'lodash'
import { ImageNodeAttrs } from 'common/Prose/nodeViews/Image/Types'

type EffectItemKey = `${ImageEffect}:${stringOrNumber}` | ImageEffect

interface ICloudinaryEffectItem<T> extends Omit<ItemProps<T>, 'key'> {
  key: EffectItemKey
}

export const CloudinaryEffectItem: <T>(props: ICloudinaryEffectItem<T>) => JSX.Element = Item

interface Props<T> extends Omit<MenuProps<ICloudinaryEffectItem<T>>, 'onAction'> {
  attrs: ImageNodeAttrs
  onEffect: () => void
}

export const CloudinaryEffectMenu = <T,>({ children, attrs, onEffect, ...props }: Props<T>) => {
  const { src } = attrs
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  const handleEffect = (key: EffectItemKey) => {
    if (!cloudinary) return

    const image = cloudinary.image(src.split('?')[0]).setDeliveryType('fetch')

    const [action, qualifier] = key.split(':')

    // @ts-ignore
    image.effect({ ...adjust, ...effect }[camelCase(action)](qualifier))
    imageStore.clearVariants()
    imageStore.createVariant({
      url: image.toURL(),
      action: snakeCase(action),
      image,
      qualifier,
    })
    onEffect()
  }

  return (
    <Menu onAction={(key) => handleEffect(key as EffectItemKey)} {...props}>
      {children}
    </Menu>
  )
}
